import TopCards from "./TopCards";
import { Container, Row, Col } from "reactstrap";

// Function to render the top cards
function DisplayTopCards({ data, match }) {
  console.log('match: ', match)
  const totalLocations=((data?.['underserved_locations_fiber']?.val ||0) + (data?.['unserved_locations_fiber']?.val ||0) +
  (data?.['underserved_locations_wireless'].val ||0)+(data?.['unserved_locations_wireless'].val ||0) +
  (data?.['unserved_locations_satellite'].val ||0)+(data?.['underserved_locations_satellite'].val ||0)+
  (data?.['unserved_locations_not_connected'].val ||0)+(data?.['underserved_locations_not_connected'].val ||0))

  return (
    <Container style={{ maxWidth: "1288px" }} className="mx-auto">
      <Row className="justify-content-center">

      <Col sm="4" lg="2">
      <TopCards
        //subtitle="Total Deployment Funds (Including Match)"
        subtitle="Total  Funds (Including Match)"
        //earning={`$${Math.round(data?.['total_deployment_funds'])||0}`} 
        earning={`$${Math.round(
          (data?.['underserved_locations_fiber'].cost ||0) + (data?.['unserved_locations_fiber']?.cost ||0)
          + (data?.['underserved_locations_wireless'].cost ||0) + (data?.['unserved_locations_wireless'].cost ||0)
          + (data?.['unserved_locations_satellite'].cost ||0) + (data?.['underserved_locations_satellite'].cost ||0)
          + (data?.['non_deployment_funds']||0)  + (data?.['remaining_funds']||0)*(100-match)/100 
              )||0}`} 



        icon="dollar"
      />
        </Col>

       
    
        <Col sm="4" lg="2">
          <TopCards
            subtitle="Locations Served with Fiber"
            earning={'' + (
              (data?.['underserved_locations_fiber']?.val || 0) + 
              (data?.['unserved_locations_fiber']?.val || 0)).toLocaleString()}
            percent={totalLocations !== 0
              ? '' + (
                (((((data?.['underserved_locations_fiber']?.val || 0) + (data?.['unserved_locations_fiber']?.val || 0))/totalLocations)*100)).toFixed(1) +'%'
              )
              : '0%'
              }
              icon="bolt"
          />
        </Col>

        <Col sm="4" lg="2">
          <TopCards
            subtitle="Locations Served with Fixed Wireless"
            earning={'' + (
              (data?.['underserved_locations_wireless']?.val || 0) +
              (data?.['unserved_locations_wireless']?.val || 0)
            ).toLocaleString()}
            percent={totalLocations !== 0
              ? '' + (
                ((((data?.['underserved_locations_wireless']?.val || 0) + (data?.['unserved_locations_wireless']?.val || 0)) / totalLocations) * 100).toFixed(1) + '%'
              )
              : '0%'
              }
            icon="wifi"
          />
        </Col>

        <Col sm="4" lg="2">
          <TopCards
            subtitle="Locations Served with Satellite"
            earning={''+(
              (data?.['unserved_locations_satellite']?.val || 0) +(data?.['underserved_locations_satellite']?.val) ||0).toLocaleString() }
            icon="sat"
            percent={totalLocations !== 0
              ? '' + (
                ((((data?.['underserved_locations_satellite']?.val || 0) + (data?.['unserved_locations_satellite']?.val || 0))/totalLocations)*100).toFixed(1) +'%'
              ) 
              : '0%'
              }
          />
        </Col>

        <Col sm="4" lg="2">
          <TopCards
            subtitle="Locations Not Served"
            earning={''+(
              (data?.['unserved_locations_not_connected']?.val || 0) +(data?.['underserved_locations_not_connected']?.val) ||0).toLocaleString() }
            icon="not_connected"
            percent={totalLocations !== 0
              ? '' + (
                ((((data?.['underserved_locations_not_connected']?.val || 0) + (data?.['unserved_locations_not_connected']?.val || 0))/totalLocations)*100).toFixed(1) +'%'
              ) 
              : '0%'
              }
          />
        </Col>

        <Col sm="4" lg="2">
      <TopCards
        subtitle="For CAIs and Other Deployment & Non-Deployment Efforts"
        //earning={`$${Math.round((data?.['non_deployment_funds'])||0)+ (Math.round(data?.['remaining_funds'])||0)}`} 
        earning={`$${Math.round((data?.['non_deployment_funds']||0)  + (data?.['remaining_funds']||0)*(100-match)/100 )}`} 
        icon="money"
        percent=''
      />
        </Col>
        
      </Row>
    </Container>
  );
}


export default DisplayTopCards;